var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgEmail = function SvgEmail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.1 31.433c.44.12.92.16 1.36.16 1.12 0 2.2-.36 3.12-1 1.32-1 2.04-2.48 2.04-4.12V9.593c0-2.36-1.6-4.4-3.84-5L9.9.593c-1.56-.44-3.2-.12-4.48.88-1.32 1-2.04 2.48-2.04 4.12v16.84c0 2.36 1.6 4.4 3.84 5l14.88 4Zm-15.92-29c.68-.56 1.52-.84 2.4-.84.32 0 .68.04 1.04.12l14.88 4c1.76.48 2.96 2.04 2.96 3.84v1.397l-13.12 7.52L4.633 5.262A3.932 3.932 0 0 1 6.18 2.433ZM4.62 7.156l9.03 12.454a.61.61 0 0 0 .49.25.6.6 0 0 0 .29-.08l13.03-7.403v14.096c0 1.24-.56 2.4-1.56 3.16-1 .76-2.24 1-3.44.68l-14.88-4c-1.76-.48-2.96-2.04-2.96-3.84V7.156Z",
    fill: "currentColor"
  })));
};

export default SvgEmail;